// @flow

import type {
  ApiError,
  ApiSuccess,
  PureAction,
} from '@travel-frontend/state-handling-sdk';
import type {AsyncAction} from 'redux/types';
import type {Customer} from 'redux/v1/customer/data/models';
import type {Errors} from 'redux/v1/customer/put/models';

import {ASYNC_TYPES, PURE} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';
import {formatDateStringToISO} from 'utils';

export const PUT_CUSTOMER = 'v1/customer/data/PUT_CUSTOMER';
export const SET_CUSTOMER_ERROR = 'v1/customer/data/SET_CUSTOMER_ERROR';

export type PutCustomerSuccess = ApiSuccess<
  *,
  {
    customer: Customer,
  }
>;
export type PutCustomerError = ApiError<Errors, *>;

export function putCustomer(
  journeyId: number,
  customer: Customer,
  token: string
): AsyncAction {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };

  return {
    types: ASYNC_TYPES(PUT_CUSTOMER),
    callAPI: () =>
      axios
        .put(
          `${cfg.bookingServiceUrl}/customer/${journeyId}`,
          {...customer, birthday: formatDateStringToISO(customer.birthday)},
          config
        )
        .then(() => ({}))
        .catch((error) => { throw error.response.data.errors; }),
    customer,
  };
}

export const setCustomerErrors = (errors: {[string]: string}): PureAction => {
  return {
    type: PURE(SET_CUSTOMER_ERROR),
    errors,
  };
};
